import { AuthRecordBuilder } from "ags/integration/builders/records/auth-record-builder";
import { RecoveryRecordBuilder } from "ags/integration/builders/records/recovery-record-builder";
import { ThemeAuthRecordBuilder } from "./theme-auth-record-builder";
import { ThemePickRecordBuilder } from "./theme-pick-record-builder";

export class ThemeRecoveryRecordBuilder extends RecoveryRecordBuilder {
    protected getPickRecordBuilder() {
        return new ThemePickRecordBuilder();
    }

    protected override getAuthRecordBuilder(): AuthRecordBuilder {
        return new ThemeAuthRecordBuilder();
    }
}
